import React from "react";
import style from "./Button.module.css";
import { Link } from "react-router-dom";

export const Button = ({ text, path = "/", mt }) => {
  return (
    <Link
      style={{ marginTop: mt }}
      to={path}
      className={style.button}
    >
      <span className={style.buttonText}>{text}</span>
    </Link>
  );
};
